import React from 'react'
import { Redirect } from 'react-router-dom'
import { isEmpty } from 'lodash'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import ServiceCategoryCard from './ServiceCategoryCard'
import ServiceCategoryNotFound from './ServiceCategoryNotFound'

import Resource from '../../stores/resource'
const CategoryStore = Resource('service-categories')

class ShowServiceCategoryPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      serviceCategory: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    CategoryStore.find(this.props.match.params.id)
      .then(result =>
        this.setState({
          serviceCategory: result.data,
          loading: false
        })
      )
      .catch(error =>
        this.setState({
          serviceCategory: {},
          error: errors.unpack(error),
          loading: false
        })
      )
  }

  _redirectTo = url => {
    this.setState({ redirect: url })
  }

  render() {
    const { loading, redirect, serviceCategory } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect} />
    if (isEmpty(serviceCategory)) return <ServiceCategoryNotFound />

    return (
      <section>
        <header>
          <PageTitle>Service category</PageTitle>
        </header>
        <ServiceCategoryCard
          serviceCategory={serviceCategory}
          editCallback={() =>
            this._redirectTo(`/service-categories/${serviceCategory.id}/edit`)
          }
          noHeightAdjust
        />
        <br />
        <BackButton />
      </section>
    )
  }
}

export default ShowServiceCategoryPage



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ShowServiceCategoryPage.jsx